var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const path = require('path');
import OSS from 'ali-oss';
function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}
let fetchFn;
export class OssResource {
    constructor(options) {
        this.host = options.host;
        this.token = options.token;
        this.urlExistTimeout = (options === null || options === void 0 ? void 0 : options.urlExistTimeout) ? options.urlExistTimeout : 3000;
        this.retryMax = (options === null || options === void 0 ? void 0 : options.retryMax) ? options.retryMax : 0;
        this.timeout = (options === null || options === void 0 ? void 0 : options.timeout) ? options.timeout : 60000;
        this.options = options;
        fetchFn = options.fetch || fetch;
        this.isNodeEnv = options.isNodeEnv || false;
    }
    fetchOssConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetchFn(`https://${this.host}/common/oss-upload-config`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.token}`
                },
            });
            const res = yield response.json();
            if (res.status_code !== 0) {
                const error = new Error(res.message);
                // @ts-ignore
                error.status_code = res.status_code;
                throw error;
            }
            return res.data.upload_config;
        });
    }
    /**
     * 初始化
     *  获取oss配置信息, 并创建oss client
     *  @return { Promise<void> }
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.ossConfig = yield this.fetchOssConfig();
                // 初始化ali-oss
                const { access_key_id: accessKeyId, access_key_secret: accessKeySecret, sts_token: stsToken, region, bucket } = this.ossConfig;
                this.client = new OSS({
                    timeout: this.timeout,
                    retryMax: this.retryMax,
                    accessKeyId, accessKeySecret, stsToken, region, bucket,
                    refreshSTSToken: () => __awaiter(this, void 0, void 0, function* () {
                        try {
                            this.ossConfig = yield this.fetchOssConfig();
                            return {
                                accessKeyId: this.ossConfig.access_key_id,
                                accessKeySecret: this.ossConfig.access_key_secret,
                                stsToken: this.ossConfig.sts_token,
                            };
                        }
                        catch (e) {
                            console.error('刷新sts token 失败');
                            if (this.uploadReject) {
                                this.uploadReject(e);
                            }
                        }
                    })
                });
            }
            catch (e) {
                console.error('create oss resource error');
                throw e;
            }
        });
    }
    /**
     * oss的资源是否存在
     * @param {string} url
     * @return { boolean }
     */
    isExist(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield fetchFn(url, {
                    method: 'HEAD'
                });
                return res.status !== 404;
            }
            catch (e) {
                return false;
            }
        });
    }
    /**
     * 上传资源到oss
     * @param key - oss key
     * @param file - 资源对象
     * @param options
     * @return { Promise<string> } 资源的url
     */
    upload(key, file, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    this.uploadReject = reject;
                    // default options
                    const defaultOptions = {
                        override: false,
                        cache: false,
                        cacheTime: 3600,
                        ignorePathPrefix: false
                    };
                    options = Object.assign({}, defaultOptions, options);
                    // 真实的oss key
                    const reallyKey = options.ignorePathPrefix ? `${key}` : `${this.ossConfig.base_path}/${key}`;
                    // 下载url
                    const url = `${this.ossConfig.download_domain}/${reallyKey}`;
                    if (!options.override) {
                        const exist = yield this.isExist(url);
                        if (exist) {
                            return resolve(url);
                        }
                    }
                    let filename = path.basename(reallyKey);
                    if (file instanceof String) {
                        file = path.normalize(file);
                    }
                    else if (!this.options.isNodeEnv && file instanceof File) {
                        filename = file.name;
                    }
                    const headers = {
                        'Content-Disposition': `attachment; filename="${encodeURIComponent(filename)}"`
                    };
                    if (!options.cache) {
                        headers['Cache-Control'] = 'no-cache';
                    }
                    else {
                        headers['Cache-Control'] = `max-age=${options.cacheTime}`;
                    }
                    try {
                        yield this.client.multipartUpload(reallyKey, file, {
                            progress: options.progress,
                            headers
                        });
                    }
                    catch (e) {
                        reject(e);
                    }
                    let loop = true;
                    const ti = setTimeout(() => {
                        loop = false;
                        reject(new Error('url exist timeout'));
                    }, this.urlExistTimeout);
                    while (loop) {
                        const exist = yield this.isExist(url);
                        if (exist) {
                            clearTimeout(ti);
                            resolve(url);
                            break;
                        }
                        yield sleep(1000);
                    }
                }
                catch (e) {
                    reject(e);
                }
            }));
        });
    }
    /**
     * 取消上传
     * @param name
     * @param uploadId
     */
    abort(name, uploadId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!name || !uploadId) {
                console.warn("name or uploadId isn't set");
                return;
            }
            return yield this.client.abortMultipartUpload(name, uploadId);
        });
    }
}
